<template>
  <!-- navbar background color -->
  <div>
    <div class="navbar-bg position-fixed"></div>
    <!-- navbar -->
    <nav class="navbar navbar-expand-lg main-navbar">
      <!-- navbar nav left -->
      <form class="form-inline mr-auto">
        <!-- navbar toggler -->
        <ul class="navbar-nav mr-3">
          <li>
            <a
              @click="switchSidebar()"
              href="#"
              data-toggle="sidebar"
              class="nav-link nav-link-lg"
            >
              <i class="fas fa-bars"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              data-toggle="search"
              class="nav-link nav-link-lg d-sm-none"
            >
              <i class="fas fa-search"></i>
            </a>
          </li>
        </ul>
      </form>
      <!-- navbar right -->
      <ul class="navbar-nav navbar-right">
        <li class="dropdown">
          <a
            href
            data-toggle="dropdown"
            class="nav-link nav-link-lg nav-link-user"
            @click.prevent
          >
            <div class="d-sm-none d-lg-inline-block">{{ env }}</div>
          </a>
        </li>

        <li class="dropdown" v-if="isShowLang">
          <a
            href="#"
            data-toggle="dropdown"
            class="nav-link dropdown-toggle nav-link-lg has-icon"
          >
            <i class="fas fa-globe" width="30" height="30"></i>
            <div
              class="d-sm-none d-lg-inline-block"
              style="padding-left: 5px; font-size: 15px; padding-bottom: 5px"
            >
              {{ $helper.getWord("languages") }}
            </div>
          </a>

          <div class="dropdown-menu dropdown-menu-right">
            <div class="dropdown-divider"></div>
            <template v-for="(locale, index) in StorageLanguages">
              <a
                class="dropdown-item"
                @click.prevent
                @click="updateLocale(locale.code)"
                style="cursor: pointer"
                :key="index"
                >{{ $helper.getWord(locale.code) }}</a
              >
              <div class="dropdown-divider" :key="'divider' + index"></div>
            </template>
          </div>
        </li>
      </ul>
      <ul class="navbar-nav navbar-right">
        <li class="dropdown">
          <a
            href="#"
            data-toggle="dropdown"
            class="nav-link dropdown-toggle nav-link-lg nav-link-user"
          >
            <img
              :src="'data:image/png;base64,' + userIconBase64"
              alt="image"
              width="30"
              height="30"
              class="rounded-circle mr-1"
              v-if="userIconBase64"
            />
            <img
              alt="image"
              :src="`${publicPath}static/img/avatar/avatar-1.png`"
              width="30"
              class="rounded-circle mr-1"
              v-if="!userIconBase64"
            />

            <div class="d-sm-none d-lg-inline-block">
              {{ $helper.getWord("hi") }}, {{ getFullName }}
            </div>
          </a>

          <div class="dropdown-menu dropdown-menu-right">
            <div class="dropdown-divider"></div>
            <router-link to="/changepassword" class="dropdown-item has-icon">
              <i class="fas fa-cog"></i> {{ $helper.getWord("account detail") }}
            </router-link>
            <div class="dropdown-divider"></div>
            <router-link
              to="/logout"
              class="dropdown-item has-icon text-danger"
            >
              <i class="fas fa-sign-out-alt"></i>
              {{ $helper.getWord("Logout") }}
            </router-link>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from "@/config";
import api from "@/api";
import helper from "@/vueHelper";
// import { bus } from "@/main";
export default {
  name: "nvabar",
  data() {
    return {
      StorageLanguages: [],
      publicPath: process.env.BASE_URL,
      env: config.environment,
      userIconBase64: null,
      //isShowSMSidebar: false
    };
  },
  components: {},
  created() {
    // alert(helper.getWord('languages'));
    if (helper.getUser()) {
      if (helper.getUser().user_id !== "11111111-1111-1111-1111-111111111111")
        this.getUserIcon();
    }
    let $vm = this;
    let loop = setInterval(function () {
      $vm.StorageLanguages = helper.getStorageLanguages();
      clearInterval(loop);
    }, 2000);
  },
  mounted() {},
  computed: {
    ...mapGetters(["getUserInfo"]),
    getFullName() {
      var fullname = "";
      // console.log(window.localStorage.getItem("ccrs_user"))
      if (window.localStorage.getItem("ccrs_user")) {
        fullname = JSON.parse(
          window.localStorage.getItem("ccrs_user")
        ).full_name;
      }
      return fullname;
    },
    isShowLang() {
      return helper.getParam("SHOW_LANG") === "true" ||
        helper.getParam("SHOW_LANG") === null
        ? true
        : false;
    },
  },
  methods: {
    ...mapActions("grid", ["actionSetToggleGridResize"]),
    ...mapActions(["actionSetToken", "actionSetMessage", "actionSetUser"]),
    updateLocale(locale) {
      helper.loading();
      api.request(
        this,
        "post",
        `/system/updateLocale`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {
            profile: helper.getProfile(),
            locale: locale,
          },
        },
        function (r) {
          localStorage.setItem("locale", r.data.user_profile.locale_code);
          this.actionSetUser(r.data.user_profile);
          location.reload();
          helper.done();
        },
        function (r) {
          helper.done();
        },
        null,
        null
      );
    },
    switchSidebar() {
      this.actionSetToggleGridResize(true);
    },
    getUserIcon() {
      let self = this;
      setTimeout(function () {
        api.request(
          self,
          "post",
          `/Firebase/getUserIcon`,
          {
            SessionID: helper.getSessionID(),
            LocaleCode: helper.getLocaleCode(),
          },
          function (r) {
            if (r.data.user_photo != null) {
              this.userIconBase64 = r.data.user_photo;
            } else {
              this.userIconBase64 = null;
            }

            helper.done();
          },
          function (r) {
            this.userIconBase64 = null;

            helper.done();
          },
          null,
          "stream"
        );
      }, 250);
    },
  },
};
</script>